import { capitalize } from "../Form/Form";

export const translations = (t) => {
    return {
        sector_id: t("external.sector-name"),
        nodo_id: t("forms.nodo"),
        equipo_id: t("forms.equipo"),
        hidraulica_id: t("forms.hidraulica"),
        dgas_mee_id: "Pozo DGA",
        tag_id: "Tag",
        cultivo_variedad_id: t("cultivos.variedad"),
        cultivo_especie_id: t("cultivos.especie"),
        tipousuario_id: t("sass.permiso"),
        tipo_pais_id: t("personal.country"),
        pais: t("personal.country"),
        usuario_id: t("login.pHolderUser"),
        fertilizante_id: t("forms.fertilizante"),
        email: t("personal.email"),
        sectores: t("mapconfig.sectores"),
        nodos: t("mapconfig.nodos"),
        integrador_id: t("sass.integrador"),
        rut_representante_legal: t("accounts.rutRepLegal"),
        nombre_representante_legal: t("accounts.nombreRepLegal"),
        direccion: t("personal.address"),
        direccion_facturacion: t("accounts.dirFacturacion"),
        telefono: t("personal.phone"),
        nombre: t("general.name"),
        prefijo: t("farms.prefijo"),
        superficie: t("area.area"),
        configurado: t("forms.mostrarMapa"),
        plantas: t("blocks.plantas"),
        goteros: t("blocks.goteros"),
        ano_plantacion: t("blocks.anioPlantacion"),
        inicio_hora_punta: t("pumpsys.inicio_hora_punta"),
        fin_hora_punta: t("pumpsys.fin_hora_punta"),
        caudal_teorico: t("farms.zone.caudalTeorico"),
        nombre_alternativo: t("farms.zone.nombreAlternativo"),
        kc: t("farms.zone.kc"),
        minimo: t("farms.zone.minimo"),
        maximo: t("farms.zone.maximo"),
        calor_limite: t("farms.zone.calorLimite"),
        helada_limite: t("farms.zone.heladaLimite"),
        porcentaje: t("forms.porcentaje"),
        mails_envio_reporte: t("farms.pozo.reportesEmails"),
        password_dga: t("farms.pozo.passwordDGA"),
        esta_habilitado: t("forms.habilitado"),
        apellido_paterno: t("sass.form.apellido_paterno"),
        apellido_materno: t("sass.form.apellido_materno"),
        password: t("sdb.password"),
        ubicacion: t("personal.location"),
        telefono_fijo: t("personal.fonoFijo"),
        telefono_movil: t("personal.fonoMovil"),
        soluble: t("forms.soluble"),
        dilucion: t("forms.dilucion"),
        nutrientes_estanque: t("forms.nutrientes"),
        descripcion: t("personal.description"),
        estanque_id: capitalize(t("farms.tipoHidraulica.tank")),
        bloque_id: t("blocks.blocks"),
        year_plantacion:  t("blocks.anioPlantacion"),
        pasaporte:  t("personal.pasaporte"),
        punto_critico_1:  t("farms.zone.puntoCritico") + " 1",
        punto_critico_2:  t("farms.zone.puntoCritico") + " 2",
        punto_critico_3:  t("farms.zone.puntoCritico") + " 3",
        punto_critico_4:  t("farms.zone.puntoCritico") + " 4",
        punto_gestion_1:  t("farms.zone.puntoGestion") + " 1",
        punto_gestion_2:  t("farms.zone.puntoGestion") + " 2",
        punto_gestion_3:  t("farms.zone.puntoGestion") + " 3",
        punto_gestion_4:  t("farms.zone.puntoGestion") + " 4",
        paleta_colores:  t("farms.fenologia.paleta"),
        tipo_renovacion:  t("farms.fenologia.tipoRenovacion"),
        estados_fenologicos:  t("farms.fenologia.estadosFenologicos"),
        plantilla_estado_fenologico_id:  t("farms.fenologia.plantilla"),
    };
};
